import { Modal } from 'react-bootstrap';
import type { VoidFunctionComponent } from 'react';

import useCreateApiWebhookSetting from '../../../../hooks/api/settings/integrations/useCreateApiWebhookSetting';
import useInputValue from '../../../../hooks/useInputValue';
import useOnMount from '../../../../hooks/useOnMount';
import Button from '../../../generic/Button/Button';
import ButtonGroup from '../../../generic/Button/ButtonGroup';
import LoaderButton from '../../../generic/Button/LoaderButton';
import FormGroup from '../../../generic/Forms/FormGroup';
import LabeledPasswordInput from '../../../generic/Forms/LabeledPasswordInput';
import LabeledTextInput from '../../../generic/Forms/LabeledTextInput';

type Props = {
  isShowing: boolean;
  onHide: () => void;
};

const CreateApiWebhookModal: VoidFunctionComponent<Props> = ({ isShowing, onHide }) => {
  const [endpoint, setEndpoint] = useInputValue('');
  const [authToken, setAuthToken] = useInputValue('');

  const { mutate: createWebhook, isLoading } = useCreateApiWebhookSetting();

  // Reset the fields on mount
  useOnMount(() => {
  });

  return (
    <Modal
      show={isShowing}
      onHide={onHide}
    >
      <Modal.Header>Create API Webhook</Modal.Header>
      <Modal.Body>
        <FormGroup>
          <LabeledTextInput labelVariant="legacy" label="Endpoint URL" value={endpoint} onChange={setEndpoint} />
          <LabeledPasswordInput label="Authentication Token" value={authToken} onChange={setAuthToken} />
        </FormGroup>
      </Modal.Body>
      <Modal.Footer>
        <ButtonGroup>
          <Button
            type="secondary"
            onClick={onHide}
          >
            Cancel
          </Button>
          <LoaderButton
            type="primary"
            isLoading={isLoading}
            onClick={async () => {
              createWebhook({ endpoint, authToken });
              setEndpoint('');
              setAuthToken('');
              onHide();
            }}
          >
            Create Webhook
          </LoaderButton>
        </ButtonGroup>
      </Modal.Footer>
    </Modal>
  );
};

export default CreateApiWebhookModal;
